module.exports = "../content/8afc539b787e482528aefa2d4dc132eb.woff2";